import { ThunkService } from '../../services/thunkService';
import * as StM from '../../models/store';

export class SubscriptionHistoryDialogActions {
    static open(id: number): (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => void {
        return (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => {
            dispatch({
                type: 'Dialogs/Admin/SubscriptionHistory/Open',
                id: id
            });
        };
    }

    static close(): (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => void {
        return (dispatch: any, getState: () => StM.IGlobalStoreState, thunkService: ThunkService) => {
            dispatch({
                type: 'Dialogs/Admin/SubscriptionHistory/Close',
            });
        };
    }
}
